"use strict";

var zetaSuggestHeader = {
  dom_selector: "ul.zeta_suggest_h",
  dom_input: "",
  showDom: function () {
    $(this.dom_selector).show();
  },
  hideDom: function () {
    $(this.dom_selector).hide();
  },
  inputFunc: function () {
    var q_word = "";
    this.dom_input = $("form input[name=q].zeta_suggest_h");
    var that = this;
    return function (event) {
      var v = that.dom_input.val();
      if (v !== q_word) {
        q_word = v;
        $(that.dom_selector).text("");
        if (q_word) {
          that.callApi(q_word);
        } else {
          that.hideDom();
        }
      }
    };
  },
  callApi: function (qw) {
    var url = "https://jun.search.zetacx.net/api/suggest/";
    var data = {
      q_word: qw,
      limit: 5,
      mode: 1,
    };
    var that = this;
    $.ajax({
      url: url,
      data: data,
      dataType: "json",
    })
      .done(function (json) {
        if (json.length === 0) {
          that.hideDom();
        } else {
          var dom = $(that.dom_selector).text("");
          for (var i = 0, l = json.length; i < l; ++i) {
            dom.append($("<li></li>").text(json[i].value));
          }
          $("li", dom).on("click", that.selectFunc);
          that.showDom();
        }
      })
      .fail(function (jqXHR) {
        that.hideDom();
        /*if (webapp.settings.env !== "live") {
          console.log(jqXHR.statusText);
        }*/
      });
  },
  selectFunc: function () {
    zetaSuggestHeader.dom_input.val($(this).text());
    zetaSuggestHeader.hideDom();
  },
};

var zetaSuggestProduct = {
  dom_selector: "ul.zeta_suggest_p",
  dom_input: "",
  showDom: function () {
    $(this.dom_selector).show();
  },
  hideDom: function () {
    $(this.dom_selector).hide();
  },
  inputFunc: function () {
    var q_word = "";
    this.dom_input = $("form input[name=q].zeta_suggest_p");
    var that = this;
    return function (event) {
      var v = that.dom_input.val();
      if (v !== q_word) {
        q_word = v;
        $(that.dom_selector).text("");
        if (q_word) {
          that.callApi(q_word);
        } else {
          that.hideDom();
        }
      }
    };
  },
  callApi: function (qw) {
    var url = "https://jun.search.zetacx.net/api/suggest/";
    var data = {
      q_word: qw,
      limit: 5,
      mode: 1,
    };
    var that = this;
    $.ajax({
      url: url,
      data: data,
      dataType: "json",
    })
      .done(function (json) {
        if (json.length === 0) {
          that.hideDom();
        } else {
          var dom = $(that.dom_selector).text("");
          for (var i = 0, l = json.length; i < l; ++i) {
            dom.append($("<li></li>").text(json[i].value));
          }
          $("li", dom).on("click", that.selectFunc);
          that.showDom();
        }
      })
      .fail(function (jqXHR) {
        that.hideDom();
        /*if (webapp.settings.env !== "live") {
          console.log(jqXHR.statusText);
        }*/
      });
  },
  selectFunc: function () {
    zetaSuggestProduct.dom_input.val($(this).text());
    if (productSearch.changeQ) {
      productSearch.changeQ();
    }
    zetaSuggestProduct.hideDom();
  },
};

var zetaSuggestMenu = {
  dom_selector: "ul.zeta_suggest_m",
  dom_input: "",
  showDom: function () {
    $(this.dom_selector).show();
  },
  hideDom: function () {
    $(this.dom_selector).hide();
  },
  inputFunc: function () {
    var q_word = "";
    this.dom_input = $("input[name=q].zeta_suggest_m");
    var that = this;
    return function (event) {
      var v = that.dom_input.val();
      if (v !== q_word) {
        q_word = v;
        $(that.dom_selector).text("");
        if (q_word) {
          that.callApi(q_word);
        } else {
          that.hideDom();
        }
      }
    };
  },
  callApi: function (qw) {
    var url = "https://jun.search.zetacx.net/api/suggest/";
    var data = {
      q_word: qw,
      limit: 5,
      mode: 1,
    };
    var that = this;
    $.ajax({
      url: url,
      data: data,
      dataType: "json",
    })
      .done(function (json) {
        if (json.length === 0) {
          that.hideDom();
        } else {
          var dom = $(that.dom_selector).text("");
          for (var i = 0, l = json.length; i < l; ++i) {
            dom.append($("<li></li>").text(json[i].value));
          }
          $("li", dom).on("click", that.selectFunc);
          that.showDom();
        }
      })
      .fail(function (jqXHR) {
        that.hideDom();
        if (webapp.settings.env !== "live") {
          console.log(jqXHR.statusText);
        }
      });
  },
  selectFunc: function () {
    zetaSuggestMenu.dom_input.val($(this).text());
    zetaSuggestMenu.hideDom();
  },
};

$(function () {


  // update pc menu. news top 3
  $("div#gnav4").each(function () {
    var that = $(this);
    $.ajax({
      url: "https://www.junonline.jp/api/news-top",
      xhrFields: {
        withCredentials: true,
      },
      dataType: "json",
    })
      .done(function (json) {
        if (json.result !== true) {
          // $(that).hide();
          return;
        }
        $("ul", that).text("");
        for (var i = 0, l = json.photologs.length; i < l; ++i) {
          $("ul", that).append(renderHtml(json.photologs[i]));
        }
        var lazyImages = [].slice.call($("img.lazy", that));
        LazyImageLoader.apply(lazyImages);
      })
      .fail(function (jqXHR) {
        /*if (webapp.settings.env !== "live") {
          console.log(jqXHR.statusText);
        }*/
      });
    var renderHtml = function (obj) {
      var dom = "";
      dom += '<li class="content-area__list">';
      dom += '<div class="content-cassette hover-opacity">';
      dom += '<a href="https://www.junonline.jp' + obj.detail_url + '">';
      dom +=
        '<div class="content-cassette__image content-cassette__image--border">';
      dom += '<img class="lazy" src="https://www.junonline.jp/common/img/lazy_dummy.svg" data-src="';
      dom += obj.image_file_3;
      dom += '" alt="">';
      dom += "</div>";
      dom += '<div class="content-cassette__content">';
      dom +=
        '<p class="text-item text-item--bold text-item--large mgb-pc--10">';
      dom += obj.title;
      dom += "</p>";
      dom += '<p class="text-item hide-line3">';
      dom += obj.lead_sentence;
      dom += "</p>";
      dom += "</p>";
      dom += "</div>";
      if (obj.tags) {
        dom += '<div class="tag-area mgt-pc--15">';
        for (var i = 0, l = obj.tags.length; i < l; ++i) {
          dom += '<span class="tag-area__link">';
          dom += obj.tags[i];
          dom += "</span>";
        }
        dom += "</div>";
      }
      dom += "</a>";
      dom += "</div>";
      dom += "</li>";
      return dom;
    };
  });

  var stylingTop = {
    renderHtml: function (obj) {
      var dom = "";
      dom += '<li class="content-area__list">';
      dom += '<a href="https://www.junonline.jp' + obj.detail_url + '" class="content-cassette">';
      dom += '<div class="content-cassette__image">';
      dom += '<img class="lazy" src="https://www.junonline.jp/common/img/lazy_dummy.svg" data-src="';
      dom += obj.image_file_3;
      dom += '" alt="">';
      dom += "</div>";
      dom += '<div class="content-cassette__content">';
      dom += '<p class="text-item ext-item--small">';
      dom += obj.brand_name;
      dom += "<br>";
      if (obj.shop_name) {
        dom += obj.shop_name;
      }
      dom += "</p>";
      dom += '<p class="text-item text-item--large text-item--gray">';
      dom += obj.display_name;
      dom += "</p>";
      dom += "</div>";
      dom += "</a>";
      dom += "</li>";
      return dom;
    },
    fetchContents: function (selector, url) {
      $(selector).each(function () {
        var that = $(this);
        $.ajax({
          url: url,
          xhrFields: {
            withCredentials: true,
          },
          dataType: "json",
        })
          .done(function (json) {
            if (json.result !== true) {
              // $(that).hide();
              return;
            }
            $("ul", that).text("");
            for (var i = 0, l = json.photologs.length; i < l; ++i) {
              $("ul", that).append(stylingTop.renderHtml(json.photologs[i]));
            }
            var lazyImages = [].slice.call($("img.lazy", that));
            LazyImageLoader.apply(lazyImages);
          })
          .fail(function (jqXHR) {
            /*if (webapp.settings.env !== "live") {
              console.log(jqXHR.statusText);
            }*/
          });
      });
    },
  };
  stylingTop.fetchContents(
    "#gnav3-2 .gnav-styling-area",
    "https://www.junonline.jp/api/styling-top?gender=女"
  );
  stylingTop.fetchContents(
    "#gnav3-3 .gnav-styling-area",
    "https://www.junonline.jp/api/styling-top?gender=男"
  );

  // suggest
  $("form input[name=q].zeta_suggest_h").on(
    "input",
    zetaSuggestHeader.inputFunc()
  );
  $("form input[name=q].zeta_suggest_p").on(
    "input",
    zetaSuggestProduct.inputFunc()
  );
  $("input[name=q].zeta_suggest_m").on(
   "input",  
   zetaSuggestMenu.inputFunc()
  );

});
